/**
 * Legacy vendor bundle — Bootstrap 5.3 + jQuery plugins.
 * jquery-global.js MUST be first.
 */
import './jquery-global.js';

import './casa-bootstrap.js';
import './casa-wizard.js';

import 'jquery-contextmenu/dist/jquery.contextMenu.js';
import flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
window.flatpickr = flatpickr;
flatpickr.localize(Spanish);

import './datatables-init.js';
import './casa-notify.js';
import 'draggabilly/dist/draggabilly.pkgd.js';
import 'multiple-select/dist/multiple-select.min.js';
